import type { ReactNode } from 'react'
import { LinaLensFullLogo } from '@lina/brand-logos'

interface LensPageLayoutProps {
  children: ReactNode
}

export function LensPageLayout({ children }: LensPageLayoutProps) {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white text-slate-900">
      <header className="border-b border-slate-200 bg-background/90 backdrop-blur">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-6">
          <LinaLensFullLogo size={25} />
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-4 py-8 sm:px-6">{children}</main>
    </div>
  )
}
